import React from "react";
//Material imports
import CloudQueue from "@mui/icons-material/CloudQueue";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { getWebSocketStatusColor } from "@limitless/common/hooks/web-sockets/WebSocketsHelper";
import { useWebSockets } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import HeaderIconButton from "../../buttons/header-icon-button/HeaderIconButton";
import InfoDialog from "./InfoDialog";
const useStyles = makeStyles({
  icon: {
    color: getWebSocketStatusColor,
    "&:hover": {
      color: "white"
    }
  }
});
const AppInfoHeaderItem = () => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const {
    wsStatus
  } = useWebSockets();
  const classes = useStyles({
    wsStatus
  });
  const handleButtonClick = () => {
    setOpenDialog(true);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderIconButton, {
    buttonId: "appInfoMenuButton",
    onButtonClick: handleButtonClick,
    tooltip: "Application Information",
    ariaLabel: "Application Information",
    icon: /*#__PURE__*/React.createElement(CloudQueue, {
      style: {
        pointerEvents: "none"
      }
    }),
    disableTooltip: openDialog,
    buttonClass: classes.icon
  }), /*#__PURE__*/React.createElement(InfoDialog, {
    open: openDialog,
    setOpen: setOpenDialog
  }));
};
export default AppInfoHeaderItem;